// [pipChat] Rebranding automatico de "Chatwoot" -> INSTALLATION_NAME em TODA
// string traduzida, via hook `postTranslation` do vue-i18n.
//
// Motivo: assim NAO precisamos editar os ~30 JSONs de traducao do upstream
// (que mudam a cada release, gerando conflito e "drift"). O rebrand acontece
// em runtime e pega inclusive strings NOVAS que o upstream adicionar no futuro.
//
// Seguranca do regex /\bChatwoot\b/g (palavra-marca isolada). NAO altera:
//  - URLs/dominios: sao minusculos (chatwoot.com) e o regex exige "C" maiusculo;
//  - variaveis camelCase ({latestChatwootVersion}): "Chatwoot" fica no meio da
//    palavra, sem fronteira \b, entao e preservado.
//
// Se INSTALLATION_NAME nao estiver definido ou for o proprio "Chatwoot"
// (instalacao nao white-label), o hook e um no-op.
export function pipchatPostTranslation(translated) {
  if (typeof translated !== 'string') return translated;
  const name = window.globalConfig?.INSTALLATION_NAME;
  if (!name || name === 'Chatwoot') return translated;
  return translated.replace(/\bChatwoot\b/g, name);
}
